import { componentName, DividerClass } from './DividerClass';
import '@descope-ui/descope-text';

customElements.define(componentName, DividerClass);

export { DividerClass, componentName };
